// OrderComments.jsx
import React, { useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { selectComments, selectOrder, setComments } from "./orderSlice";
import { addCommentOrder, getOrderComments, deleteCommentOrder } from "./orderApi";
import "./orderComments.css";
import { texts } from "../../Common/common";
import { selectLanguage, selectRole } from "../../Login/loginSlice";

export default function OrderComments() {
  const dispatch = useDispatch();
  const role = useSelector(selectRole);
  const currentLanguage = useSelector(selectLanguage);
  const comments = useSelector(selectComments);
  const order = useSelector(selectOrder);

  const [showFormAddComment, setShowFormAddComment] = useState(false);
  const [comment, setComment] = useState("");
  const inputRef = useRef();

  const handleAddComment = () => {
    if (!comment.trim()) return;

    addCommentOrder({ order_id: order.id, text: comment }, (data) => {
      setComment("");
      if (data.res) {
        getOrderComments({ order_id: order.id }, (data) => {
          setShowFormAddComment(false);
          dispatch(setComments(data.comments));
        });
      } else {
        alert("Ошибка");
      }
    });
  };

  const handleMenu = (commentItem) => {
    const choice = window.confirm(`Удалить комментарий?\n\n"${commentItem.text}"`);
    if (choice) {
      confirmDelete(commentItem.id);
    } else {
      navigator.clipboard.writeText(commentItem.text);
      alert("Скопировано в буфер");
    }
  };

  const confirmDelete = (commentId) => {
    deleteCommentOrder({ id: commentId }, (data) => {
      if (data.res) {
        getOrderComments({ order_id: order.id }, (data) => {
          dispatch(setComments(data.comments));
        });
      } else {
        alert("Ошибка при удалении");
      }
    });
  };

  return (
    <div className="order-part-4">
      <div className="comments-header">
        <span>{texts[currentLanguage].comments}</span>
        {role !== "doctor" && (
          <button className="add-comment-btn" onClick={() => setShowFormAddComment(true)}>
            ➕
          </button>
        )}
      </div>

      <div className="comments-list">
        {!comments || comments.length === 0 ? (
          <p>Комментариев нет</p>
        ) : (
          comments.map((commentItem, i) => (
            <div
              key={i}
              className="comment-item"
              onClick={() => handleMenu(commentItem)}
            >
              {i + 1}. {commentItem.text}
            </div>
          ))
        )}
      </div>

      {showFormAddComment && (
        <div className="modal">
          <div className="modal-content">
            <h3>Комментарий</h3>
            <textarea
              ref={inputRef}
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              placeholder="Комментарий..."
              autoFocus
            />
            <div className="modal-actions">
              <button onClick={() => setShowFormAddComment(false)}>Отмена</button>
              <button onClick={handleAddComment}>Добавить</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
